import React from 'react'
import PropTypes from 'prop-types'
import { shipmentDeliveryInfoValueProps } from '../copy/shipmentDeliveryInfoConfig'
import styles from '../styles.module.scss'

const DeliveryInfoModalContent = ({ deliveryContentData }) => {
    if (!deliveryContentData) return null

    return (
        <div className={styles.contentContainer}>
            <ul className={styles.contentList}>
                {deliveryContentData['contentKeys'].map((contentKey) => {
                    const contentData = shipmentDeliveryInfoValueProps[contentKey]
                    return (
                        <li
                            key={`${contentKey}`}
                            className={styles.contentItem}
                        >
                            <h3 className={styles.contentItemTitle}>{contentData.title}</h3>
                            <ul className={styles.contentItemCopyList}>
                                {contentData.content.map((contentString, index) => {
                                    return (
                                        <li
                                            key={`${contentKey}-content-${index}`}
                                            className={styles.contentItemCopy}
                                            dangerouslySetInnerHTML={{ __html: contentString }}
                                        />
                                    )
                                })}
                            </ul>
                            <p
                                className={styles.contentDisclaimer}
                                dangerouslySetInnerHTML={{ __html: contentData.disclaimer }}
                            />
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

DeliveryInfoModalContent.propTypes = {
    deliveryContentData: PropTypes.object
}

export default DeliveryInfoModalContent
